var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainTopo"},[_c('div',{staticClass:"left"},[_c('TopoLeft')],1),_c('div',{staticClass:"right"},[_c('Topology')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }